import { api, endpoint } from '@/plugins/axios'

const getFeesReport = async body => api.post(endpoint.REPORTS_FEES, body)

const getFeesDuesReport = async params => api.get(endpoint.REPORTS_FEES_DUES, { params })

const getFeesPaymentModeSummary = async body => api.post(endpoint.REPORTS_FEES_PAYMENT_MODE_SUMMARY, body)

const getFeesCollectionSummary = async params => api.get(endpoint.REPORTS_FEES_COLLECTION_SUMMARY, { params })

const getStaffAttendanceReport = async body => api.post(endpoint.REPORTS_STAFF_ATTENDANCE, body)

const getStaffLeaveReport = async body => api.post(endpoint.REPORTS_STAFF_LEAVE, body)

const getStaffLeaveSummary = async body => api.post(endpoint.REPORTS_STAFF_LEAVE_SUMMARY, body)

const getEnquiryReport = async body => api.post(endpoint.REPORTS_ENQUIRY, body)

const getEnquiryFollowUps = async params => api.get(endpoint.REPORTS_ENQUIRY_FOLLOWUPS, { params })

const getHomeworkReport = async body => api.post(endpoint.REPORTS_HOMEWORK, body)

const getExaminationSectionReport = async params => api.get(endpoint.REPORTS_EXAMINATION, { params })

export default {
  getFeesReport,
  getFeesDuesReport,
  getFeesPaymentModeSummary,
  getFeesCollectionSummary,
  getStaffAttendanceReport,
  getStaffLeaveReport,
  getStaffLeaveSummary,
  getEnquiryReport,
  getEnquiryFollowUps,
  getHomeworkReport,
  getExaminationSectionReport,
}
